import React from 'react';

interface CardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  /** Remove padding — useful when the card body handles its own spacing */
  noPadding?: boolean;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  className = '',
  onClick,
  noPadding = false,
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        bg-white rounded-3xl shadow-card border border-faint
        ${noPadding ? '' : 'p-5 sm:p-6'}
        ${onClick ? 'cursor-pointer card-interactive' : 'transition-shadow duration-200'}
        animate-fade-in
        ${className}
      `}
    >
      {title && (
        <div className="mb-4">
          <h3 className="text-sm font-semibold text-soft tracking-wider">
            {title}
          </h3>
          {subtitle && (
            <p className="mt-1 text-sm text-soft">{subtitle}</p>
          )}
        </div>
      )}

      <div>{children}</div>
    </div>
  );
};
